if (window.customElements && !customElements.get('article-toc')) {
  class ArticleTOC extends HTMLElement {
    constructor() {
      super();
      this.contentSelector = this.dataset.articleContent || '.article-template__content';
      this.headings = [];
      this.observer = null;
      this.activeId = null;
    }

    connectedCallback() {
      // Wait for DOM to be fully ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    init() {
      const content = document.querySelector(this.contentSelector);
      if (!content) return;

      this.headings = Array.from(content.querySelectorAll('h2, h3'));
      if (this.headings.length === 0) {
        // Hide TOC if no headings found
        this.style.display = 'none';
        return;
      }

      this.generateIds();
      this.buildList();
      this.setupScrollSpy();
      this.setupClickHandlers();
    }

    generateIds() {
      this.headings.forEach((heading, index) => {
        if (!heading.id) {
          const slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
          heading.id = slug || 'section-' + (index + 1);
        }
      });
    }

    buildList() {
      // Build list for all TOC instances on the page (mobile + desktop)
      const allTocElements = document.querySelectorAll('article-toc');
      allTocElements.forEach((tocElement) => {
        const list = tocElement.querySelector('.article-toc__list');
        if (!list) return;
        list.innerHTML = '';

        this.headings.forEach((heading) => {
          const li = document.createElement('li');
          li.className = 'article-toc__item';
          if (heading.tagName === 'H3') {
            li.className += ' article-toc__item--indent';
          }

          const a = document.createElement('a');
          a.href = '#' + heading.id;
          a.className = 'article-toc__link';
          a.textContent = heading.textContent.trim();
          a.dataset.tocTarget = heading.id;

          li.appendChild(a);
          list.appendChild(li);
        });
      });
    }

    setupScrollSpy() {
      const options = {
        rootMargin: '-100px 0px -66% 0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActive(entry.target.id);
          }
        });
      }, options);

      this.headings.forEach((heading) => {
        this.observer.observe(heading);
      });
    }

    setActive(id) {
      if (this.activeId === id) return;
      this.activeId = id;

      // Update all TOC instances (mobile + desktop)
      const allLinks = document.querySelectorAll('.article-toc__link');
      allLinks.forEach((link) => {
        if (link.dataset.tocTarget === id) {
          link.classList.add('article-toc__link--active');
        } else {
          link.classList.remove('article-toc__link--active');
        }
      });
    }

    setupClickHandlers() {
      document.querySelectorAll('.article-toc__link').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.dataset.tocTarget;
          const target = document.getElementById(targetId);
          if (target) {
            const offset = 100;
            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
            // Update URL hash without jumping
            history.pushState(null, '', '#' + targetId);
          }
        });
      });
    }
  }

  customElements.define('article-toc', ArticleTOC);
}
